<div class="public-shell">
  <header class="shell-header">
    <a routerLink="/" class="brand">AfriFood</a>

    <nav class="header-nav">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Accueil</a>
      <a routerLink="/privacy-policy" routerLinkActive="active">Confidentialité</a>
      <a routerLink="/data-deletion-request" routerLinkActive="active">Suppression des données</a>
    </nav>
  </header>

  <main class="shell-main">
    <router-outlet></router-outlet>
  </main>

  <footer class="shell-footer">
    <span>Site public temporairement en maintenance.</span>
  </footer>
</div>
